import React, {Component} from 'react';
import BottonPushes from './Shared/BottonPushes';

class SFBottonPushes extends Component {
    render() {
        var buttonPusheClass = ["push-consultation-tool", "push-newsletter"]
        return (
            <BottonPushes bottonPushes={this.props.pushButton} buttonPusheClass={buttonPusheClass}  />
        )
    }
}

export default SFBottonPushes;